export const unregister = () => {
	navigator.serviceWorker.getRegistrations().then((registrations) => {
		registrations.forEach((registration) => {
			if (registration.scope.endsWith('/wiki')) {
				registration.unregister();
			}
		});
	});
};
